import React from "react"
import PropTypes from "prop-types"
import ColorSwatch from "@/components/core/ColorSwatch/ColorSwatch"

const SwatchItems = props => {
  const {
    variantList,
    setVariant,
    variant,
    clickSwatch = () => {},
  } = props || {}
  return (
    <div className={`swatch-list d-flex`}>
      {variantList?.map((val, i) => {
        const validSwatch = val?.colorUrl?.split("/")
        if (validSwatch[validSwatch?.length - 1] === "swatch_NA") {
          return null
        }
        return (
          <div
            role="radio"
            key={`${val?.id}-${i}`}
            aria-label={val.label}
            aria-checked={val.id === variant ? true : false}
          >
            <ColorSwatch
              type="selector"
              id={val.id}
              name={val.name}
              value={val.value}
              label={val.label}
              colorUrl={val.colorUrl}
              checked={val?.id === variant}
              onClick={() => {
                setVariant(val?.id)
                clickSwatch(val?.id)
              }}
              key={i}
            />
          </div>
        )
      })}
    </div>
  )
}

SwatchItems.propTypes = {
  variant: PropTypes.string.isRequired,
  setVariant: PropTypes.func.isRequired,
  variantList: PropTypes.array.isRequired,
}

export default SwatchItems
